$(function () {

	// Ввод только цифр
		$B.on('keypress', '.js-number', function(e){
			let charCode = (e.which) ? e.which : e.keyCode;
			if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			  return false;
			}
		});
	
	// Деактивация кнопки отправки формы при снятии галочки с чекбокса согласия
		$('body').on('change', '.js-agree', function () {
			let $this = $(this);
			let btn = $this.closest('.js-form').find('.submit');
			if ($this.is(':checked')) {
				btn.removeAttr("disabled");
			} else {
				btn.attr("disabled", true);
			}
		});
	
		function getFormData(formData, data, previousKey) {
			if (data instanceof Object) {
				Object.keys(data).forEach(key => {
					const value = data[key];
					if (value instanceof Object && !Array.isArray(value)) {
						return getFormData(formData, value, key);
					}
					if (previousKey) {
						key = `${previousKey}[${key}]`;
					}
					if (Array.isArray(value)) {
						value.forEach(val => {
							formData.append(`${key}[]`, val);
						});
					} else {
						formData.append(key, value);
					}
				});
			}
		}
	
	// Валидация формы
		let formValidate = function() {
	
			let form = $('.js-form');
	
			form.each(function(){
				
				let thisForm = $(this);
				let url = thisForm.attr('action');
	
				const validationConfig = {
					focusInvalid: false,
					highlight: function(element) {
						$(element).closest(".form-field").addClass('form-field--error');
					},
					unhighlight: function(element) {
						$(element).closest(".form-field").removeClass('form-field--error');
					},
					submitHandler: function(form, event) {
						event.preventDefault();

						let data = new FormData(),
							formParams = thisForm.serializeArray();

						$.each(formParams, function(i, val) {
							data.append(val.name, val.value);
						});

						$.ajax({
							url: thisForm.attr('action'),
							type: 'POST',
							processData: false,
							contentType: false,
							data: data,
							beforeSend: function (data) {

								thisForm.find('button').prop('disabled', false);
								thisForm[0].reset();

								let $select2 = $('.js-select:not(.js-filter-input)');
								if ($select2.length) {
									$select2.each(function () {
										$(this).val('').trigger('change');
									})
								}
								let idThank = thisForm.data('thank');
								$(idThank).addClass('is-show');

							},
							success: function (data) {
								if (data['error']) {
									console.log('error');
								}
							},
							error: function (xhr, ajaxOptions, thrownError) {
								console.log(xhr.status);
								console.log(thrownError);
							}
						});
					}
				}
	
				let smartToken = thisForm.find('[name="smart-token"]');
	
				let validateFormArgs = {
					ignore: ".hidden:not([name='smart-token'])",
					rules: {
						'smart-token': 'required',
					},
					messages: {
						'smart-token': '* Вы должны выполнить антиспам проверку'
					}
				}
	
				if(smartToken) {
					Object.assign(validationConfig, validateFormArgs);
				}
				
				thisForm.validate(validationConfig);
	
			});
		};
	
		formValidate();
	
		window.formValidate = formValidate;
	
		$B.on('click', 'label.error',function(){
			$(this).hide().siblings('input,textarea').focus();
	
		});
	
		$B.on('keyup', 'input',function(){
			$(this).siblings('label.error').hide();
		});
	
		$B.on('change', '.js-select-sort', function(){
			console.log('rfd')
			$(this).closest('.form-field').removeClass('form-field--error');
		});
	
		$('.popup-thank').on('click', function(){
			$(this).removeClass('is-show');
		});
	
	});
	
	
	